export default __webpack_public_path__ + "static/media/stage2_phn.d3ada757.png";